import React from 'react';

const EllipseTopLeft = () => {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="691" height="1567" viewBox="0 0 691 1567" fill="none">
    <path opacity="0.7" d="M-521.357 -774C131.288 -774 690 -250.132 690 396C690 1042.13 131.288 1566 -521.357 1566C-1173.97 1566 -1703 1042.16 -1703 396C-1703 -250.164 -1173.97 -774 -521.357 -774Z" stroke="url(#paint0_linear_12395_20935)" stroke-opacity="0.15" stroke-width="2"/>
    <defs>
      <linearGradient id="paint0_linear_12395_20935" x1="-491.643" y1="-775" x2="-491.643" y2="1567" gradientUnits="userSpaceOnUse">
        <stop stop-color="#899B30"/>
        <stop offset="0.50226" stop-color="#AC7E4C"/>
        <stop offset="1" stop-color="#D6CFF8"/>
      </linearGradient>
    </defs>
  </svg>
  );
}

export default EllipseTopLeft; 